export default "__VITE_ASSET__BE94XZCG__"